import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-solid-svg-icons";
import CartItem from "components/CartItem";
import PropTypes from "prop-types";

const CheckoutReview = ({ stepsReviewVisible, items, onCartRemove }) => {
  return (
    <div className="checkout__step">
      <div className="checkout__step-header">
        <FontAwesomeIcon size="lg" icon={faCircle} />
        <span className="checkout__step-number">3 of 3</span>
        <h2>Review</h2>
      </div>

      {stepsReviewVisible && (
        <div className="checkout__step-body">
          {items.map(item => (
            <CartItem
              key={item.sku}
              sku={item.sku}
              productName={item.productName}
              author={item.author}
              retailPrice={item.retailPrice}
              unitPrice={item.unitPrice}
              courseBundleCount={item.courseBundleCount}
              omsSavedcartLineItemId={item.omsSavedcartLineItemId}
              onCartRemove={onCartRemove}
              showRemove={false}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default CheckoutReview;

CheckoutReview.propTypes = {
  stepsReviewVisible: PropTypes.bool.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  items: PropTypes.array.isRequired,
  onCartRemove: PropTypes.func.isRequired
};
